export const breakpoints = {
  xl: '1200px', // => @media (min-width: 1200px) { ... }
  lg: '992px', // => @media (min-width: 992px) { ... }
  md: '769px', // => @media (min-width: 769px) { ... }
  sm: '406px', // => @media (min-width: 406px) { ... }
};
